<template>
  <v-row>
    <v-col cols="12" md="3" class="mx-auto">
      <v-switch
        :label="$t('table.allow_custom_dates')"
        true-value="1"
        false-value="0"
        v-model="form.allow_custom_dates"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="2" class="mx-auto">
      <v-switch
        :label="$t('table.auto_accept_order')"
        true-value="1"
        false-value="0"
        v-model="form.auto_accept_order"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="2" class="mx-auto">
      <v-switch
        :label="$t('table.premium')"
        true-value="1"
        false-value="0"
        v-model="form.premium"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="2" class="mx-auto">
      <v-switch
        :label="$t('table.available')"
        true-value="1"
        false-value="0"
        v-model="form.available"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="2" class="mx-auto">
      <v-switch
        :label="$t('table.visible')"
        true-value="1"
        false-value="0"
        v-model="form.visible"
      ></v-switch>
    </v-col>

    <v-col cols="12" md="6" lg="4">
      <form-group :validator="$v.form.name" name="name" attribute="fields.name">
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="text"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.name"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.sub_name"
        name="sub_name"
        attribute="fields.sub_name"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="text"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.sub_name"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.label"
        name="label"
        attribute="fields.label"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="text"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.label"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.duration_in_nights"
        name="duration_in_nights"
        attribute="fields.nights_count"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.duration_in_nights"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.cancel_before_start_in_hours"
        name="cancel_before_start_in_hours"
        attribute="fields.cancel_before_start_in_hours"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.cancel_before_start_in_hours"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.reserve_before_start_in_hours"
        name="reserve_before_start_in_hours"
        attribute="fields.reserve_before_start_in_hours"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.reserve_before_start_in_hours"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.return_pct"
        name="return_pct"
        attribute="fields.return_pct"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.return_pct"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>

    <v-col cols="12" md="6" lg="4">
      <form-group
        :validator="$v.form.tourism_cities"
        name="tourism_cities"
        attribute="fields.tourism_cities"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-autocomplete
            multiple
            chips
            small-chips
            :items="tourismCities"
            item-text="name"
            item-value="id"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.tourism_cities"
            :messages="$t('required')"
          ></v-autocomplete>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-autocomplete
        :label="$t('fields.categories')"
        multiple
        small-chips
        chips
        deletable-chips
        :items="categories"
        item-text="name"
        item-value="id"
        dense
        outlined
        v-model="form.categories"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-autocomplete
        multiple
        chips
        clearable
        :items="tags"
        item-text="name"
        item-value="id"
        dense
        :label="$t('fields.tags')"
        outlined
        v-model="form.tags"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12">
      <form-group
        :validator="$v.form.country"
        name="country"
        attribute="fields.country"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-select
            dense
            outlined
            v-bind="attrs"
            v-on="listeners"
            :items="countries"
            item-text="name"
            item-value="id"
            v-model="form.country"
            :messages="$t('required')"
          ></v-select>
        </template>
      </form-group>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FirstStep",
  props: {
    tourismCities: {
      type: Array,
      default: () => []
    },
    countries: {
      type: Array,
      default: () => []
    },

    tags: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },

    form: {
      type: Object,
      default: () => {}
    },

    isEdit: {
      type: Boolean,
      default: false
    }
  },
  inject: ["$v"]
};
</script>
